import { ArchivingFingerprint } from '@app/modules/archiving/models/archiving-common.model';

// ENUMS #############################################################
// API enums *********************************************************
export enum ArchivingProceduralDocumentTypeEnum {
	PROCEDURAL_DOCUMENT = 'proceduralDocument',
	OTHER_APPLICABLE_DOCUMENT = 'otherApplicableDocument',
}

// UI enums *********************************************************
// UPLOAD STATUS
export enum ProcessStatusEnum {
	DELETED = 'deleted',
	FAILED = 'failed',
	NOT_ASKED = 'not asked',
	STARTED = 'started',
	SUCCESS = 'success',
	UPLOADING = 'uploading'
}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IArchivingProceduralDocumentImportData {
	id?: string;

	file: File;

	filename: string;

	documentType: ArchivingProceduralDocumentTypeEnum;

	markedAsImported: boolean;

	uploadForbidden: boolean;

	processStatus: ProcessStatusEnum;

	prettyFilesize: string;

	allowedFilesizeExceeded: boolean;

	uploadProgress: number;

	uploadError?: { short: string, long: string };
}


// ENUMS #############################################################
// API enums ********************************************************
export enum ArchivingProceduralDocumentMalwareScanStatusEnum {
	FOUND = 'malwareFound',
	OK = 'ok',
	SCANNING = 'malwareScanning'
}

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ArchivingProceduralDocumentTMO {
	created?: Date = undefined;
	createdBy?: string = undefined;
	fingerprint?: ArchivingFingerprint = undefined;
	id?: string = undefined;
	lastModified?: Date = undefined;
	lastModifiedBy?: string = undefined;
	malwareScanStatus?: ArchivingProceduralDocumentMalwareScanStatusEnum = undefined;
	name?: string = undefined;
	proceduralDocumentationId?: string = undefined;
	type?: ArchivingProceduralDocumentTypeEnum = undefined;
}

export class ArchivingCreateDocumentRequestTMO {
	metadata: ArchivingDocumentRequestMetadata = undefined;
	files?: Array<File> = undefined;
}

export class ArchivingDocumentRequestMetadataTMO {
	type?: ArchivingProceduralDocumentTypeEnum = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingProceduralDocument extends ArchivingProceduralDocumentTMO {
}

export class ArchivingCreateDocumentRequest extends ArchivingCreateDocumentRequestTMO {
}

export class ArchivingDocumentRequestMetadata extends ArchivingDocumentRequestMetadataTMO {
}

